<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="committee_loading">
          <form>
            <fieldset>
              <legend>{{ $t('thesis.evaluator') }}</legend>
              <div class="row">
                <div class="col-md-12">
                  <div id="container-table">
                    <table class="table ui-table table-hover">
                      <thead>
                        <tr>
                          <th style="width: 15%">
                            {{ $t('thesis.employeeName') }}
                          </th>
                          <th style="width: 15%">
                            {{ $t('thesis.description') }}
                          </th>
                          <th style="width: 10%">{{ $t('thesis.score') }}</th>
                          <th style="width: 10%">{{ $t('thesis.grade') }}</th>
                          <th style="width: 10%">
                            {{ $t('thesis.scoreRemark') }}
                          </th>
                          <th style="width: 10%">{{ $t('thesis.status') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(item, index) in model.committees"
                          :key="index"
                        >
                          <td>
                            {{ item.committee_name }}
                          </td>
                          <td>
                            {{ item.remark }}
                          </td>
                          <td>
                            <input
                              v-model="item.score"
                              type="number"
                              step="any"
                              class="form-control only-border-bottom"
                            />
                          </td>
                          <td class="ts-py-2 ts-px-3">
                            <input
                              v-model="item.grade"
                              type="text"
                              step="any"
                              class="form-control only-border-bottom"
                            />
                          </td>
                          <td class="ts-py-2 ts-px-3">
                            <input
                              v-model="item.score_remark"
                              type="text"
                              step="any"
                              class="form-control only-border-bottom"
                            />
                          </td>
                          <td class="ts-py-2 ts-px-3">
                            <select
                              class="form-control only-border-bottom"
                              v-model="item.status"
                            >
                              <option value="">{{ $t('select') }}</option>
                              <option
                                v-for="(status, index) in status"
                                :key="index"
                                :value="status.value"
                              >
                                {{ status.label }}
                              </option>
                            </select>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </fieldset>
            <div class="row mb-3">
              <div class="col-md-12 text-right mt-3">
                <ts-button @click.prevent="$emit('close')">
                  {{ $t('cancel') }}
                </ts-button>
                <ts-button
                  class="btn btn-primary ml-2"
                  :waiting="committee_save"
                  @click.prevent="committee"
                  >{{ $t('save') }}</ts-button
                >
              </div>
            </div>
          </form>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'form-committe',
  data () {
    return {
      saving: false,
      waiting_save: false,
      errors: new Errors(),
      committee_loading: false,
      committee_save: false,
      loading: false,
      status: [
        {
          value: 'Passed',
          label: 'Passed'
        },
        {
          value: 'Failed',
          label: 'Failed'
        }
      ],
      model: {
        committees: [],
        thesis_reg_id: null,
      }
    }
  },
  computed: {
    ...mapState('thesis', ['editData'])
  },
  created () {
    this.setEditData()
    this.fectCommittee()
  },
  methods: {
    ...mapActions('thesis', ['getCommittee']),
    committee () {
      this.committee_save = true
      this.$store
        .dispatch('thesis/committee', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('before-close')
          this.$emit('close')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.committee_save = false
        })
    },
    async setEditData () {
      this.editData.committees.forEach(item => {
        this.model.committees.push({
          committee_name: item.committee_name,
          remark: item.remark,
          score: item.score,
          grade: item.grade,
          score_remark: item.score_remark,
          status: item.status,
        })
      })
      this.model.thesis_reg_id = this.editData.thesis_reg_id
    },
    fectCommittee () {
      this.committee_loading = true
      this.$store
        .dispatch('thesis/getCommittee', this.model)
        .then(() => (this.committee_loading = false))
        .catch(error => {
          this.committee_loading = false
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.committee_loading = false
        })
    }
  }
}
</script>
<style lang="css" scoped>
#container-table {
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
::-webkit-scrollbar {
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  background: rgb(194, 194, 194);
}
table td {
  vertical-align: middle;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
  outline: none;
}
.table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
#amountValue tr > td {
  padding: 5px;
}
</style>
